import EventsTable from "@/machines/components/table/events-table";
import AlertsTable from "@/machines/components/table/alerts-table";
import { Machine } from "@/machines/types/machine";

interface MachineDetailTablesSectionProps {
  machine: Machine;
  setSelectedTime: (time: number | null, origin?: "internal" | "external") => void;
}

const MachineDetailTablesSection = ({
  machine,
  setSelectedTime,
}: MachineDetailTablesSectionProps) => {
  const device_mxid = machine?.device_mxid ?? "";

  return (
    <div className={"grid xl:grid-cols-2 gap-4"}>
      <EventsTable device_mxid={device_mxid} />
      <AlertsTable device_mxid={device_mxid} setSelectedTime={setSelectedTime} />
    </div>
  );
};

export default MachineDetailTablesSection;
